import { Component,Inject } from '@angular/core';
import { DOCUMENT } from  '@angular/common';
import { Router,NavigationCancel,NavigationEnd, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators'
import { AppService } from './app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'my-new-app';
  public apiLocation: string;
  public ntPrinter: string;
  public ntAddress: string;
    constructor(@Inject(DOCUMENT) private document: Document) {
    const appRoot = this.document.querySelector('app-root');
    this.apiLocation = appRoot?.getAttribute('API_Location') || '';
    this.ntPrinter = appRoot?.getAttribute('NT_Printer') || '';
    this.ntAddress = appRoot?.getAttribute('NT_Address') || '';
  }
}
